/* searchtoggle */
window.addEventListener('load', (event) => {
    const searchToggle = $('.searchToggleTrigger');
    const searchBar = $('.searchBarElement');
    const searchBarFocusElement = $('.autocompleteSearch');
    const wrapper = $('.wrapper');
    let searchBarHidden = true;

    function closeSearch() {
        searchBar.slideUp(300);
        searchToggle.focus();
    }

    function openSearch() {
        searchBar.slideDown(300);
        searchBarFocusElement.focus();
    }

    searchToggle.click(function (event) {
        event.preventDefault();
        searchBarHidden = !searchBarHidden;
        $(this).toggleClass('__active');
        wrapper.toggleClass('__searchactive');
        searchBar.attr('aria-hidden', searchBarHidden);
        if (searchBarHidden) {
            closeSearch();
        } else {
            openSearch();
        }
    });
});